"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
const computePrice_1 = require("../computePrice");
/**
 * Transfers order items to the target order
 * @param event - The event containing transfer details
 * @param prevState - The previous state of the order
 * @returns The updated order
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c;
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status) ||
        !(0, utils_1.canPerformTransfer)((_b = (_a = event.transferItemsFrom) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.tableId, (_c = event.transferItemsTo) === null || _c === void 0 ? void 0 : _c.tableId)) {
        return order;
    }
    const allOrderItemsToCopy = event.transferItemsFrom.flatMap(sourceOrder => sourceOrder.orderItems
        .filter(sourceItem => !order.orderItems.some(orderItem => { var _a; return ((_a = orderItem.transferInfo) === null || _a === void 0 ? void 0 : _a.fromOrderItemId) === sourceItem.id; }))
        .map(item => {
        var _a;
        const { newTransferItemId, ...rest } = item;
        return {
            ...rest,
            id: newTransferItemId,
            originalOrderItemId: '',
            adjustments: [],
            surchargeAmount: 0,
            discountAmount: 0,
            paymentStatus: domain_1.OrderPaymentStatus.PENDING,
            transferInfo: {
                transferredAt: event.timestamp,
                transferredBy: {
                    id: event.triggeredBy,
                    name: event.transferredByName,
                },
                fromOrderId: sourceOrder.orderId,
                fromOrderItemId: item.id,
                fromTableId: sourceOrder === null || sourceOrder === void 0 ? void 0 : sourceOrder.tableId,
                toOrderId: event.transferItemsTo.orderId,
                toTableId: (_a = event.transferItemsTo) === null || _a === void 0 ? void 0 : _a.tableId,
            },
        };
    }));
    order.orderItems = (0, lodash_uniqby_1.default)([...allOrderItemsToCopy, ...order.orderItems], 'id');
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=transferItems.js.map